import angular from 'angular';

import VersionServ from '../../services/version';

import UpdateNotificationCtrl from './lf-update-notification.controller';

function UpdateNotification() {
	return {
		restrict: 'A',
		template: require('./lf-update-notification.html'),
		controller: UpdateNotificationCtrl
	};
}

export default angular.module('directives.lf-update-notification', [VersionServ])
	.directive('lfUpdateNotification', UpdateNotification)
	.name;



// WEBPACK FOOTER //
// ./project/directives/lf-update-notification/index.js